import Vue from 'vue'
import VueRouter from 'vue-router'
import uyu_product from '../views/uyu_product/index.vue'
import uyu_about from '../views/uyu_about/index.vue'
import uyu_home from '../views/uyu_home/index.vue'
import uyu_service from '../views/uyu_service/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/uyu_home'
  },
  {
    path: '/uyu_product',
    name: 'uyu_product',
    component: uyu_product,
    meta: {
      title: '产品中心 - 优眼智家',
      description: '优眼智家产品中心，提供同视视觉训练仪、检训一体机、调节视功能检查仪、屈光视功能检查仪等专业视功能检查与训练设备。',
      keywords: '优眼智家产品,同视视觉训练仪,检训一体机,调节视功能检查仪,屈光视功能检查仪,视功能训练设备'
    }
  },
  {
    path: '/uyu_about',
    name: 'uyu_about',
    component: uyu_about,
    meta: {
      title: '关于我们 - 优眼智家',
      description: '了解优眼智家，专注视功能检查与训练设备研发的企业，致力于为用户提供智能眼健康解决方案。',
      keywords: '优眼智家公司,眼健康企业,视功能检查设备厂家'
    }
  },
  {
    path: '/uyu_home',
    name: 'uyu_home',
    component: uyu_home,
    meta: {
      title: '优眼智家 - 专业视功能检查与训练设备',
      description: '优眼智家专注于视功能检查与训练设备的研发与生产，提供智能眼健康解决方案。产品已获批第二类医疗器械注册证。',
      keywords: '优眼智家,视功能检查,视觉训练,眼健康,医疗器械'
    }
  },
  {
    path: '/uyu_service',
    name: 'uyu_service',
    component: uyu_service,
    meta: {
      title: '服务中心 - 优眼智家',
      description: '优眼智家服务中心，提供专业的眼健康咨询服务和技术支持，联系我们：400-050-6688。',
      keywords: '优眼智家服务,眼健康咨询,售后服务,技术支持'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由切换时更新页面 meta 信息
router.beforeEach((to, from, next) => {
  // 更新页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  // 更新 meta description
  if (to.meta && to.meta.description) {
    let metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', to.meta.description)
    }
  }
  // 更新 meta keywords
  if (to.meta && to.meta.keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]')
    if (metaKeywords) {
      metaKeywords.setAttribute('content', to.meta.keywords)
    }
  }
  // 更新 canonical URL
  let canonicalLink = document.querySelector('link[rel="canonical"]')
  if (canonicalLink) {
    canonicalLink.setAttribute('href', 'https://test.uyu.com' + to.path)
  }
  next()
})

export default router
